function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
import isEmptyString from "./isEmptyString";
import isString from "./isString";
var sanitizeErrors = function sanitizeErrors(errors) {
  Object.keys(errors).forEach(function (item) {
    // First we want to check if there is nested Object/Array inside errors{}
    // we will then remove empty arrays or items inside those Objects
    // Do NOT recurse into empty object. This is bad input data but handle anyway!
    if (errors[item] != null && _typeof(errors[item]) === "object" && Object.keys(errors[item]).length !== 0) {
      sanitizeErrors(errors[item]);
    } // Formik doesn't like empty items in the errors object, it considers any entry as an error.
    var isUndefined = typeof errors[item] === "undefined";
    var isErrorEmptyString = isString(errors[item]) && isEmptyString(errors[item]);
    var isEmptyObject = errors[item] !== null && _typeof(errors[item]) === "object" && !Object.keys(errors[item]).length;
    if (errors[item] === null || isUndefined || isErrorEmptyString || isEmptyObject) {
      delete errors[item];
    }
  });
  return errors;
};
export default sanitizeErrors;